import { PropsWithChildren } from "react"
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome"
import { Box, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    sectionIconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "1.25rem",
        height: "1.5rem",
    },
}))

export const SectionWithIcon = ({ icon, children }: PropsWithChildren<{ icon: FontAwesomeIconProps["icon"] }>) => {
    const { classes } = useStyles()
    return (
        <Stack direction="row" justifyContent="start" spacing=".5rem" alignItems="flex-start">
            <Box className={classes.sectionIconContainer}>
                <FontAwesomeIcon icon={icon} color="#94A3B8" />
            </Box>
            {children}
        </Stack>
    )
}
